import { getOrphanGraphElements } from '@/orchestrate/journeys/helpers';
import { useEmailsStore } from '@/stores/emails.store';
import { deleteEdge, deleteNode } from '@/stores/api/journeys-graph.api';

export async function removeOrphanGraphElements (journeyId, messageGraph) {
    const { orphanNodes, orphanEdges, sanitized } = getOrphanGraphElements(messageGraph);

    for (const { id } of orphanEdges) {
        // eslint-disable-next-line no-await-in-loop
        await deleteEdge(journeyId, id);
    }
    for (const { id } of orphanNodes) {
        // eslint-disable-next-line no-await-in-loop
        await deleteNode(journeyId, id);
    }

    return sanitized;
}

export function getAllEmailFieldsOfJourney (messages = []) {
    const emailMessages = messages.filter((message) => message.type === 'Email');
    const fields = emailMessages
        .map((email) => {
            const emailEntity = useEmailsStore().getEmailById(email.id);

            return emailEntity?.emailSettings?.recipientMetadataPropertyName;
        })
        .filter((field) => field != null && field !== '');

    // Remove duplicates
    return [...new Set(fields)];
}
